import { useWhatsNewWindow } from "./useWhatsNewWindow";

export function WhatsNewWindowController() {
  useWhatsNewWindow();
  return null;
}
